import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { API } from "../../config";
import axios from "axios";
import { useSelector } from "react-redux";

// Fetch settings
const fetchSettings = async (userInfo) => {
    const config = {
        headers: {
            Authorization: `Bearer ${userInfo.token}`,
        },
    };

    const { data } = await axios.get(`${API}/setting`, config);
    return data;
};

export const useListSettings = () => {
    const { userInfo } = useSelector((state) => state.userLogin);

    return useQuery({
        queryKey: ['settings'],
        queryFn: () => fetchSettings(userInfo),
        enabled: !!userInfo,
        staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
        cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    });
};

// Update setting
const updateSetting = async ({ category, setting }, userInfo) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${userInfo.token}`,
        },
    };

    const { data } = await axios.put(
        `${API}/setting/?category=${category}`,
        { ...setting },
        config
    );
    return data;
};

export const useUpdateSetting = () => {
    const queryClient = useQueryClient();
    const { userInfo } = useSelector((state) => state.userLogin);

    return useMutation({
        mutationFn: ({ category, setting }) => updateSetting({ category, setting }, userInfo),
        onSuccess: (data) => {
            // Invalidate settings query to refetch updated data
            queryClient.invalidateQueries(['settings']);
            // Optionally update the cache directly
            queryClient.setQueryData(['settings'], data);
        },
        onError: (error) => {
            console.error("Error updating setting:", error);
            const message =
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message;
            // Handle error appropriately
            throw new Error(message);
        },
    });
};